<template>
    <v-container fluid >
        <v-toolbar flat color="white">
        <v-toolbar-title>Заказчики</v-toolbar-title>
        <v-divider
                class="mx-2"
                inset
                vertical
        >
        </v-divider>
        <v-btn v-if="this.role != 'ROLE_EXPERT'" color="info" dark class="mb-2" @click="openDialog">Добавить Заказчика</v-btn>

        <v-dialog v-model="contactDialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitleContact }}</span>
                    </v-card-title>
                    <v-alert
                            :value="successAlertContact"
                            dismissible
                            type="success"
                    >
                        {{successTextContact}}
                    </v-alert>
                    <v-alert
                            :value="errorAlertContact"
                            color="error"
                            icon="warning"

                    >
                        {{errorTextContact}}
                    </v-alert>
                    <v-form
                            ref="formContact"
                            v-model="validContact"
                            lazy-validation
                    >
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 field-block>
                                       <div v-if="editContactPersons.fio.length >= 76 && editContactPersons.fio.length < 100" class='max-length-block'>Осталось {{100 - editContactPersons.fio.length}} символов</div>

                                        <v-text-field v-model="editContactPersons.fio" :rules="contactRules" maxlength="100" required>
                                            <template slot="label">
                                                ФИО <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="editContactPersons.phone" @focus="prefix2='+7'" :prefix="(editContactPersons.phone != '' || prefix2 != '') ? '+7' : ''" mask="(###) ###-##-##" :rules="phoneRules" :counter="10" required>
                                            <template slot="label">
                                                Телефон <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block>
                                       <div v-if="editContactPersons.email.length >= 76 && editContactPersons.email.length < 100" class='max-length-block'>Осталось {{100 - editContactPersons.email.length}} символов</div>

                                        <v-text-field v-model="editContactPersons.email" :rules="emailRules" maxlength="100" required>
                                            <template slot="label">
                                                Адрес элетронной почты <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click="closeContact">Отменить</v-btn>
                            <v-btn color="success" flat @click="saveContact">Сохранить</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>

        <v-dialog v-if="this.role != 'ROLE_EXPERT'" v-model="dialog" max-width="900px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-alert
                        :value="successAlert"
                        dismissible
                        type="success"
                >
                    {{successText}}
                </v-alert>
                <v-alert
                        :value="errorAlert"
                        color="error"
                        icon="warning"

                >
                    {{errorText}}
                </v-alert>
                <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                >
                    <v-card-text>
                        <v-container grid-list-md style="padding-bottom: 0">
                            <v-layout wrap>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field style="display: none"></v-text-field>
                                    <v-text-field v-model="editedItem.inn" :rules="innRules" :counter="10" mask="##########" :error-messages="inputErrors.inn" @blur="innRequest(editedItem.inn)" required>
                                        <template slot="label">
                                            ИНН <span class='error-file'>*</span>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 field-block>
                                    <div v-if="editedItem.email.length >= 76 && editedItem.email.length < 100" class='max-length-block'>Осталось {{100 - editedItem.email.length}} символов</div>

                                    <v-text-field v-model="editedItem.email" :rules="emailRules" :error-messages="inputErrors.email" maxlength="100" required>
                                        <template slot="label">
                                            Адрес элетронной почты <span class='error-file'>*</span>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 field-block>
                                    <div v-if="editedItem.name.length >= 176 && editedItem.name.length < 200" class='max-length-block'>Осталось {{200 - editedItem.name.length}} символов</div>
                                    <v-textarea v-model="editedItem.name" rows="2" :rules="requiredRules200" :error-messages="inputErrors.name" maxlength="200">
                                        <template slot="label">
                                            Наименование <span class='error-file'>*</span>
                                        </template>
                                    </v-textarea>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.phone" @focus="prefix='+7'" height="51" :prefix="(editedItem.phone != '' || prefix != '') ? '+7' : ''" mask="(###) ###-##-##" :rules="phoneRules" :counter="10" :error-messages="inputErrors.phone" required>
                                        <template slot="label">
                                            Телефон <span class='error-file'>*</span>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 field-block>
                                    <div v-if="editedItem.address.length >= 488 && editedItem.address.length < 512" class='max-length-block'>Осталось {{512 - editedItem.address.length}} символов</div>
                                    <v-textarea
                                            rows="2"
                                            v-model="editedItem.address"
                                            :rules="requiredRules512" maxlength="512"  :error-messages="inputErrors.address"
                                    >
                                        <template slot="label">
                                            Адрес (место нахождения) <span class='error-file'>*</span>
                                        </template>
                                    </v-textarea>
                                </v-flex>
                                <v-flex xs12 sm6 md6 field-block>
                                    <div v-if="editedItem.mailAddress.length >= 488 && editedItem.mailAddress.length < 512" class='max-length-block'>Осталось {{512 - editedItem.mailAddress.length}} символов</div>
                                    <v-textarea
                                            rows="2"
                                            v-model="editedItem.mailAddress"
                                            :rules="requiredRules512" maxlength="512" :error-messages="inputErrors.mailAddress"
                                    >
                                        <template slot="label">
                                            Почтовый адрес <span class='error-file'>*</span>
                                        </template>
                                    </v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <v-container style="padding-top: 0">
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-toolbar flat color="white">
                                        <h3>Контактные лица</h3>
                                        <v-spacer></v-spacer>
                                        <v-btn flat @click="openContactDialog"><v-icon dark small >add</v-icon> Добавить</v-btn>

                                    </v-toolbar>
                                    <v-data-table
                                            :headers="headers2"
                                            :items="contactPersons"
                                            hide-actions
                                            :light=true
                                            no-data-text=""
                                            rows-per-page-text="Строк на странице"
                                            class="elevation-1"
                                    >
                                        <template  slot="items" slot-scope="props">
                                            <td>{{ props.item.fio }}</td>
                                            <td>{{ '+7 ' + phoneNumberFormat(props.item.phone) }}</td>
                                            <td>{{ props.item.email }}</td>
                                            <td class="justify-center layout px-0">

                                                <v-tooltip top>
                                                    <v-btn slot="activator" color="primary" flat icon @click="editContactItem(props.item)">
                                                        <v-icon small>fa-pencil</v-icon>
                                                    </v-btn>
                                                    <span>Редактировать</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <v-btn slot="activator" color="red" flat icon @click="deleteContactItem(props.item)">
                                                        <v-icon small>fa-trash</v-icon>
                                                    </v-btn>
                                                    <span>Удалить</span>
                                                </v-tooltip>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">Отменить</v-btn>
                        <v-btn color="success" flat @click="save">Сохранить</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-spacer></v-spacer>
        <v-btn color="info" dark class="mb-2" @click="getCustomers">
            <i class="material-icons">
                refresh
            </i>  Обновить
        </v-btn>
        <v-flex xs6 sm3>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    class="table-search"
                    label="Поиск"
                    single-line
                    hide-details
            >
            </v-text-field>
        </v-flex>

    </v-toolbar>
        <v-alert
                :value="deleteTextAlert"
                type="success"
                dismissible
        >
            {{deleteText}}
        </v-alert>
        <v-data-table
                :headers="headers"
                :role="role"
                :items="customers"
                :pagination.sync="pagination"
                :search="search"
                :loading="tableLoading"
                :light=true
                no-data-text=""
                rows-per-page-text="Строк на странице"
                :rows-per-page-items='[ 15, 30, 50, { "text": "все", "value": -1 } ]'
                class="elevation-1"
        >
            <template  slot="items" slot-scope="props">
                <td @dblclick="user_info(props.item)">{{ props.item.name }}</td>
                <td @dblclick="user_info(props.item)">{{ props.item.inn }}</td>
                <td @dblclick="user_info(props.item)">{{ props.item.address }}</td>
                <td @dblclick="user_info(props.item)">{{ props.item.mailAddress }}</td>
                <td @dblclick="user_info(props.item)">{{ props.item.phoneFormat }}</td>
                <td @dblclick="user_info(props.item)">{{ props.item.email }}</td>
                <td class="action-buttons justify-center">

                    <v-tooltip v-if="role != 'ROLE_EXPERT'" top>
                        <v-btn slot="activator" color="primary" flat icon @click="editItem(props.item)">
                            <v-icon small>fa-pencil</v-icon>
                        </v-btn>
                        <span>Редактировать</span>
                    </v-tooltip>
                    <v-tooltip v-if="role != 'ROLE_EXPERT'" top>
                        <v-btn slot="activator" color="red" flat icon @click="deleteItem(props.item)">
                            <v-icon small>fa-trash</v-icon>
                        </v-btn>
                        <span>Удалить</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn slot="activator" color="primary" flat icon @click="user_info(props.item)">
                            <v-icon small >fa-ellipsis-v</v-icon>
                        </v-btn>
                        <span>Посмотреть</span>
                    </v-tooltip>

                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                По вашему запросу "{{ search }}" ничего не найдено.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :total-visible="7" :length="pages"></v-pagination>
        </div>
    </v-container>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
    export default{
        data: () => ({
            backUrl: null,
            prefix: '',
            prefix2: '',
            valid: true,
            validContact: true,
            requiredRules512: [
                v => !!v || 'Значение должно быть заполнено',
                v => v.length <= 512 || 'Должно быть не более 512 символов'
            ],
            requiredRules200: [
                v => !!v || 'Значение должно быть заполнено',
                v => v.length <= 200 || 'Должно быть не более 200 символов'
            ],
            contactRules: [
                v => !!v || 'Значение должно быть заполнено',
                v => v.length >= 5 || 'Должно быть не меньше 5 символов'
            ],
            innRules: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length == 10) || 'ИНН должен содержать 10 цифр',
            ],
            phoneRules: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length == 10) || 'Введите телефон в формате +7 (ххх) ххх-хх-хх'
            ],
            emailRules: [
                 v => !!v || 'Значение должно быть заполнено',
                 v => v.length <= 100 || 'Должно быть не более 100 символов',
                 v => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(v) || 'Адрес элетронной почты должен быть действительным'
                 },
            ],
            tableLoading: false,
            error_text: '',
            dialog: false,
            contactDialog: false,
            headers: [
                { text: 'Наименование',value: 'name'},
                { text: 'ИНН', value: 'inn' },
                { text: 'Адрес (место нахождения)', value: 'address' },
                { text: 'Почтовый адрес', value: 'mailAddress' },
                { text: 'Телефон', value: 'phone', width: 150 },
                { text: 'Адрес элетронной почты', value: 'email' },
                { text: 'Действия',align: 'center',class: 'flight-actions', sortable: false }
            ],
            headers2: [
                { text: 'ФИО',value: 'fio', sortable: false},
                { text: 'Телефон',value: 'phone', sortable: false},
                { text: 'Адрес элетронной почты',value: 'email', sortable: false},
                { text: 'Действия',align: 'center', sortable: false }
            ],
            customers: [],
            pagination: {},
            editedIndex: -1,
            editedIndex2: -1,
            search: '',
            inputErrors:[],

            deleteText:'',
            deleteTextAlert: false,

            successAlert:false,
            errorAlert:false,
            successText:'',
            errorText:'',

            successAlertContact:false,
            errorAlertContact:false,
            successTextContact:'',
            errorTextContact:'',

            deletedItem: {
                id: '',
                uuid: '',
            },
            editedItem: {
                id: '',
                uuid: '',
                name: '',
                inn: '',
                address:'',
                mailAddress:'',
                phone:'',
                email:'',

            },
            defaultItem: {
                name: '',
                inn: '',
                address:'',
                mailAddress:'',
                phone:'',
                email:'',
            },
            token:'',
            role:'',
            counter: 0,
            contactPersons: [],
            contactPersonsEdit: [],
            editContactPersons: {
                fio: '',
                phone: '',
                email: '',
            },
            defaultContactItem: {
                fio: '',
                phone: '',
                email: '',
            },
            deletedContactItem: [],
        }),

        created () {
            this.token = localStorage.getItem('token');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.getCustomers();
            this.getContactPersons();
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Новый заказчик' : 'Редактировать заказчика'
            },

            formTitleContact(){
                return this.editedIndex2 === -1 ? 'Новое контактное лицо' : 'Редактировать контактное лицо'
            },

            pages () {
                if (this.pagination.rowsPerPage == null ||
                    this.customers.length == null
                ) return 0
                return Math.ceil(this.customers.length / this.pagination.rowsPerPage)
            }

        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            contactDialog (val) {
                val || this.closeContact()
            },
        },

        methods: {

            innRequest(inn){

                if(inn.length == 10 && this.contactDialog == false){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/info/inn?value=' + inn,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            this.editedItem.name = response.data.name
                            this.editedItem.address = response.data.address
                            this.editedItem.mailAddress = response.data.postAddress
                        }
                    })
                }

            },

            phoneNumberFormat(item){
                if(item) {
                    let USNumber = item.match(/(\d{3})(\d{3})(\d{2})(\d{2})/);
                    return "(" + USNumber[1] + ") " + USNumber[2] + "-" + USNumber[3] + "-" + USNumber[4];
                }
            },

            getCustomers(){
                this.deleteText = ''
                this.deleteTextAlert = false

                axios({
                    method: 'get',
                    url: this.backUrl + '/api/customers',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    if(response.data.data){
                        this.customers = response.data.data;
                        for(let i = 0;i < this.customers.length; i++) {
                            Vue.set(this.customers[i], 'phoneFormat','+7 ' + this.phoneNumberFormat(this.customers[i].phone))
                        }
                    }
                })
            },

            getContactPersons(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/persons',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    if(response.data) {
                        this.contactPersonsEdit = response.data.data;
                    }
                })
            },

            openDialog(){
                this.inputErrors = ''
                this.$refs.form.resetValidation()
                this.dialog = true
            },

            editItem (item) {
                for(let i= 0; i < this.contactPersonsEdit.length; i++){
                    if(this.contactPersonsEdit[i].customerId == item.id){
                        this.contactPersons.push(this.contactPersonsEdit[i])
                    }
                }
                this.inputErrors = ''
                this.editedIndex = this.customers.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.deletedItem = Object.assign({}, item)
                const index = this.customers.indexOf(item)

                if(confirm('Вы уверены, что хотите удалить этого заказчика ?')) {
                    axios({
                        method: 'delete',
                        url: this.backUrl + '/api/customers',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.deletedItem.id,
                            uuid: this.deletedItem.uuid,
                        },
                    }).then(() => {
                        this.customers.splice(index, 1)
                        this.deleteTextAlert = true
                        this.deleteText = 'Успешно удален'
                        setTimeout(() => {
                            this.deleteTextAlert = false
                        }, 3000)

                    }).catch(error => {
                        if(error.response.data.code == 401){
                            this.$router.push('/login');
                        }
                    });
                }
            },

            close () {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.contactPersons = [{
                        id: '',
                        fio: '',
                        phone: '',
                        email: '',
                    }],
                    this.contactPersons = []
                    this.editedIndex = -1
                    this.prefix = ''
                    this.inputErrors = ''
                    this.errorAlert = false
                    this.successAlert = false
                    this.successText = ''
                    this.deleteText = ''
                    this.deleteTextAlert = false

                }, 300)
            },

            save () {
                this.inputErrors = ''
                if (this.$refs.form.validate()) {
                if (this.editedIndex == -1) {

                    axios({
                        method: 'post',
                        url: this.backUrl + '/api/customers',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            name: this.changeQuotes(this.editedItem.name),
                            inn: this.editedItem.inn,
                            address: this.editedItem.address,
                            mailAddress: this.editedItem.mailAddress,
                            phone: this.editedItem.phone,
                            email: this.editedItem.email,
                        },
                    }).then(response => {
                        this.getCustomers();
                        this.inputErrors = ''

                        this.customers.push(this.editedItem)

                        for(let i = 0; i < this.contactPersons.length;i++){
                            axios({
                                method: 'post',
                                url: this.backUrl + '/api/persons',
                                withCredentials: true,
                                headers:{
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    fio: this.contactPersons[i].fio,
                                    phone: this.contactPersons[i].phone,
                                    email: this.contactPersons[i].email,
                                    customerId: JSON.parse(response.data.objectJson).id,
                                },
                            })
                        }

                        this.successText = 'Успешно добавлен'
                        this.successAlert = true
                        setTimeout(() => {
                            this.close()
                        }, 1500)
                    })
                    .catch(error => {

                        if (error.response.data.code == 401) {
                            this.$router.push('/login');
                        }
                        let errors = error.response.data.rows;
                        this.inputErrors = errors

                    });

                } else {

                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/customers',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            uuid: this.editedItem.uuid,
                            id: this.editedItem.id,
                            name: this.changeQuotes(this.editedItem.name),
                            inn: this.editedItem.inn,
                            address: this.editedItem.address,
                            mailAddress: this.editedItem.mailAddress,
                            phone: this.editedItem.phone,
                            email: this.editedItem.email,
                        },
                    }).then(response => {
                        this.getCustomers();

                        Object.assign(this.customers[this.editedIndex], this.editedItem)


                        for(let i = 0; i < this.deletedContactItem.length;i++){
                            if(this.deletedContactItem[i].customerId){
                                axios({
                                    method: 'delete',
                                    url: this.backUrl + '/api/persons',
                                    withCredentials: true,
                                    headers:{
                                        'Authorization': 'Basic ' + this.token
                                    },
                                    data: {
                                        id: this.deletedContactItem[i].id,
                                        uuid: this.deletedContactItem[i].uuid,
                                    },
                                })
                            }
                        }

                        for(let i = 0; i < this.contactPersons.length;i++){
                            if(this.contactPersons[i].customerId){
                                axios({
                                    method: 'put',
                                    url: this.backUrl + '/api/persons',
                                    withCredentials: true,
                                    headers:{
                                        'Authorization': 'Basic ' + this.token
                                    },
                                    data: {
                                        id: this.contactPersons[i].id,
                                        uuid: this.contactPersons[i].uuid,
                                        fio: this.contactPersons[i].fio,
                                        phone: this.contactPersons[i].phone,
                                        email: this.contactPersons[i].email,
                                        customerId: this.editedItem.id,
                                    },
                                })
                            }else{
                                axios({
                                    method: 'post',
                                    url: this.backUrl + '/api/persons',
                                    withCredentials: true,
                                    headers:{
                                        'Authorization': 'Basic ' + this.token
                                    },
                                    data: {
                                        fio: this.contactPersons[i].fio,
                                        phone: this.contactPersons[i].phone,
                                        email: this.contactPersons[i].email,
                                        customerId: JSON.parse(response.data.objectJson).id,
                                    },
                                })
                            }
                        }
                        this.inputErrors = ''
                            this.successText = 'Успешно изменен'
                            this.successAlert = true
                            setTimeout(() => {
                                this.getContactPersons();
                                this.close()
                            }, 1500)
                       })
                        .catch(error => {
                            if (error.response.data.code == 401) {
                                this.$router.push('/login');
                            }
                            let errors = error.response.data.rows;
                            this.inputErrors = errors

                        });
                    }
                }

            },

            user_info(val){
                   this.$router.push({ name: 'customer_info', params: { id: val.id } })
            },

            openContactDialog(){
                this.editedIndex2 = -1
                this.prefix2 = ''
                this.$refs.formContact.resetValidation()
                this.editContactPersons = Object.assign({}, this.defaultContactItem)
                this.contactDialog = true
            },

            editContactItem (item) {
                this.editedIndex2 = this.contactPersons.indexOf(item)
                this.editContactPersons = Object.assign({}, item)
                this.contactDialog = true
            },

            deleteContactItem (item) {
                this.deletedContactItem.push(item)
                const index = this.contactPersons.indexOf(item)

                if(confirm('Вы уверены, что хотите удалить ?')) {
                    this.contactPersons.splice(index, 1)
                    setTimeout(() => {
                        this.deleteTextAlert = false
                    }, 3000)
                }
            },

            closeContact () {
                this.contactDialog = false
                setTimeout(() => {
                    this.editContactPersons = Object.assign({}, this.defaultContactItem)
                    this.editedIndex2 = -1
                    this.prefix2 = ''
                    this.successAlertContact = false
                    this.successTextContact = ''
                }, 300)
            },

            saveContact () {
                if (this.$refs.formContact.validate()) {
                    if (this.editedIndex2 == -1) {
                            this.contactPersons.push(this.editContactPersons)
                            this.successTextContact = 'Успешно добавлен'
                            this.successAlertContact = true
                            setTimeout(() => {
                                this.closeContact()
                            }, 1500)
                    } else {
                            Object.assign(this.contactPersons[this.editedIndex2], this.editContactPersons)
                            this.successTextContact = 'Успешно изменен'
                            this.successAlertContact = true
                            setTimeout(() => {
                                this.closeContact()
                            }, 1500)
                    }
                }
            },

            changeQuotes(val){
               return val.replace(/«|»|''|'/g,"\"");
            }
        }
    }
</script>
<style>
    table td,table th {
        padding: 0 12px!important;
    }
    .table-search{
         margin-bottom: 13px!important;
     }

</style>
